// 折线图公用配置
import { isEmpty, timetransition } from '@/utils/common'
import { defaultUnit } from '@/utils/convert'
import { getPrimaryColor } from '@/utils/theme'
const t = vm.$t.bind(vm)

/**
 * 折线图配置
 * @param unit 单位  temp | hum
 * @param valMin y轴最小值
 * @param valMax y轴最大值
 * @returns
 */
export const chartOptions = ({ unit, valMin, valMax }) => {
  return {
    visualMap: [
      {
        type: 'piecewise',
        show: false,
        dimension: 0,
        seriesIndex: 0,
        pieces: []
      }
    ],
    series: [],
    // 图表位置
    grid: {
      left: '4%',
      right: '4%',
      bottom: '10%'
    },
    dataZoom: [
      {
        // 启用数据区域缩放
        type: 'inside',
        realtime: true,
        filterMode: 'none',
        start: 0,
        end: 100
      },
      {
        type: 'slider',
        realtime: true,
        // backgroundColor: 'rgba(48,78,114,0.4)',
        dataBackground: {
          areaStyle: {
            color: getPrimaryColor()
          }
        }
      }
    ],
    toolbox: {
      feature: {
        dataZoom: {
          yAxisIndex: 'none'
        },
        restore: {}
      }
    },
    // 拐点提示窗
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        animation: false
      },
      formatter: params => {
        params = params[0]

        if (params.value[1] === '---') {
          return ''
        }
        const no = params.data.no
        return (
          $t('public.time') +
          ':' +
          timetransition(params.name) +
          '<br>' +
          `${$t('device.current_probe_value')}: ${params.value[1]}${unit}` +
          '<br>' +
          `${$t('integration.monitoring_interval')}: ${isEmpty(params.data.min) ? '' : params.data.min}${
            unit
          } - ${isEmpty(params.data.max) ? '' : params.data.max}${
            unit
          }` +
          '<br />' +
          (no ? `${$t('integration.equipment_no')}:` + no : '')
        )
      }
    },
    xAxis: {
      type: 'time'
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: false
      },
      // y轴最大最小值要根据监测区间重新计算
      min: function (value) {
        const min = parseInt(value.min) - 5
        // 展示更小的
        if (valMin) {
          return value.min < valMin ? min : valMin - 5
        } else {
          return min
        }
      },
      max: function (value) {
        const max = parseInt(value.max) + 5
        // 展示更大的
        if (valMax) {
          return value.max > valMax ? max : valMax + 5
        } else {
          return max
        }
      },
      name: unit,
      axisLine: {
        lineStyle: {
          color: getPrimaryColor(),
          width: 1.8
        }
      }
    }
  }
}

export const seriesItem = (probe) => ({
  data: [],
  type: 'line',
  smooth: true,
  showSymbol: false,
  // name: $t('integration.line_chart'),
  markPoint: {
    data: [
      {
        type: 'max',
        name: 'Max'
      },
      {
        type: 'min',
        name: 'Min'
      }
    ],
    label: {
      normal: {
        formatter: (param) => {
          console.log('probe=', probe)
          if(probe === 'magnetism'){
            return param.data.value === 1 ? t('public.open') : t('public.close')
          }else{
            return param.data.value
          }
        }
      }
    }
  },
  markArea: {
    itemStyle: {
      color: getPrimaryColor(),
      opacity: 0.3
    },
    silent: true
    // data: rangeData || []
  }
})

export const markLine = (min, max) => {
  return {
    data: [
      {
        name: 'min',
        yAxis: min,
        lineStyle: {
          type: 'dashed',
          color: 'red'
        }
      },
      {
        name: 'max',
        yAxis: max,
        lineStyle: {
          type: 'dashed',
          color: 'red'
        }
      }
    ]
  }
}
